import React from "react";
import { Select } from "../../createBadge/form/components";
import ReplayIcon from "@mui/icons-material/Replay";
import { MenuItem } from "@mui/material";
import colors from "../../../common/styles/colors";
import { useTranslation } from "react-i18next";
import { SelectChangeEvent } from "@mui/material/Select";
import QrScanner from "qr-scanner";

interface Props {
  getAvailableCameraDevices: () => Promise<any>;
  selectedCameraDevice?: QrScanner.Camera;
  onDeviceChange: (event: SelectChangeEvent<string>) => void;
  cameraDevices: Array<QrScanner.Camera>;
}

const classes = {
  reloadIcon: {
    transform: "scaleX(-1) rotate(-45deg)",
    color: colors.primary,
    cursor: "pointer"
  }
};

export const FreyaPrintSettingsDeviceSelector: React.FC<Props> = ({
  getAvailableCameraDevices,
  selectedCameraDevice,
  onDeviceChange,
  cameraDevices
}) => {
  const { t } = useTranslation("common");

  return (
    <Select
      renderIcon={() => <ReplayIcon onClick={getAvailableCameraDevices} fontSize="small" sx={classes.reloadIcon} />}
      label={t("kioskPrintSettings.cameraDeviceSelect")}
      name={t("kioskPrintSettings.cameraDeviceSelect")}
      value={selectedCameraDevice?.id || ""}
      onChange={onDeviceChange}
      native={false}
    >
      {cameraDevices.map(device => (
        <MenuItem key={device.id} value={device.id}>
          {device.label}
        </MenuItem>
      ))}
    </Select>
  );
};
